var _rect, _circle, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingCornerLowerRightRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 80,
    viewBox: "0 0 106 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    width: 80,
    height: 106,
    rx: 4,
    transform: "rotate(90 106 0)",
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.666,
    cy: 40.1123,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5113 51.999H64.9113V38.199C64.9113 34.799 64.9113 27.399 54.6613 27.399C50.8613 27.399 47.1113 28.549 44.4613 31.249L47.6113 34.399C49.2113 32.899 51.5113 31.899 54.0113 31.899C57.2113 31.899 59.5113 33.449 59.5113 36.399V37.049H58.0113C52.0113 37.049 42.9113 37.599 42.9113 45.399C42.9113 50.149 47.2113 52.599 51.6613 52.599C54.8613 52.599 57.6613 51.399 59.3613 48.699H59.5113V51.999ZM59.1613 42.599C59.1613 45.949 57.2113 48.099 53.1113 48.099C51.1613 48.099 48.9113 47.149 48.9113 44.949C48.9113 41.499 54.6113 41.249 57.9113 41.249H59.1613V42.599Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 97.332,
    y: 52.4443,
    width: 2.5,
    height: 14,
    rx: 1.25,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingCornerLowerRightRight);
export default __webpack_public_path__ + "static/media/jobconfig-binding-corner-lowerRight-right.529faaaa17c12e635c5e39762cfd2e3f.svg";
export { ForwardRef as ReactComponent };